export const chats = {
  chatListChatIfoAttachmentsText: 'Attachment(s) sent',
  chatListChatNoMessagesText: 'No messages yet',
  chatArchivedTitle: 'Archived chats',
  chatsCreatePrivateCurtainTitle: 'New chat',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Search',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Create',
  chatCreateButtonTitle: 'Next',
  chatCreateNewGroupHeader: 'New group',
  chatGroupNameInputTitle: 'Group name',
  chatLogoTitle: 'Edit',
  chatCreateGroupButtonTitle: 'Create group',
  chatRequiredFieldsAlert: 'Group name must be specified!',
  chatsCreateGroupChatLongTitleAlertText: 'Please use a shorter title!',
  chatsCreateGroupChatLBigImageAlertText: 'Please, choose a smaller image!',
  chatsNewChatInputPlaceholder: 'Write a message',
  chatsNewChatAddedBigImageAlertText: 'Please, choose a smaller image!',
  chatOwnersArchiveOptionText: 'Archive',
  chatOwnersEditGroupOptionText: 'Edit',
  chatOwnersManageGroupOptionText: 'Manage members',
  chatOwnersChangeGroupOptionText: 'Change group owner',
  chatOwnersLeaveGroupOptionText: 'Leave',
  chatOwnersDeleteGroupOptionText: 'Delete chat',
  chatpopupArchivedTitle: 'Archive Chat',
  chatpopupArchivedDescription: 'Are you sure?',
  chatArchiveGroupButtonTitleYes: 'Confirm',
  chatArchiveGroupButtonTitleCancel: 'Cancel',
  chatEditGroupHeader: 'Edit chat',
  chatEditGroupEditLogoTitle: 'Edit',
  chatEditGroupButtonTitle: 'Save',
  chatGroupEditAlertText: 'Save successful!',
  chatManageGroupHeader: 'Manage',
  chatManageGroupButtonTitle: 'Add member',
  chatManageGroupSaveButtonTitle: 'Save',
  chatAddUsersGroupHeader: 'Add members',
  chatAddUsersGroupButtonTitle: 'Confirm',
  chatAddUsersGroupSearchInputPlaceholder: 'Search',
  chatOwnershipTransferHeader: 'Transfer ownership',
  chatOwnershipTransferSearchInputPlaceholder: 'Search',
  chatOwnershipTransferButtonTitle: 'Confirm',
  chatOwnerMarkText: '(you)',
  chatOwnershipTransferAlertText: 'Ownership transferred!',
  chatOwnerLeaveGroupTitle: 'Leave the group',
  chatOwnerLeaveGroupDescription: 'You are an owner of chat so you need to assign a new owner before you leave.',
  chatOwnerLeaveGroupButtonTitleYes: 'Choose',
  chatOwnerLeaveGroupButtonTitleNo: 'Cancel',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Archive',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Chat members',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Leave',
  chatsGroupChatMemberCurtainTitle: 'Chat members',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Search',
  chatsGroupChatMemberCurtainOwnerMarkText: '(owner)',
  chatsGroupChatLeavePopupTitle: 'Leave',
  chatsGroupChatLeavePopupText: 'Are you sure?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Cancel',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Confirm',
  chatDeleteGroupTitle: 'Delete chat',
  chatDeleteGroupDescription: 'Chat and its history will be deleted for all participants, continue?',
  chatDeleteGroupButtonTitleYes: 'Confirm',
  chatDeleteGroupButtonTitleNo: 'Cancel',
  chatsPrivateChatCurtainArchOptionTitle: 'Archive',
  chatsEditMessage: 'Edit message',
  chatsCopyMessage: 'Copy message',
  chatsDeleteMessage: 'Delete message',
  chatsSelectMessage: 'Select message',
  chatMarkTextEdit: '(edited)',
  chatCopyMessageAlertText: 'Message copied!',
  chatDeleteMessageTitle: 'Delete Message',
  chatDeleteMessageDescription: 'Delete this message?',
  chatDeleteMessageButtonTitleYes: 'Confirm',
  chatDeleteMessageButtonTitleNo: 'Cancel',
  chatSelectButtonDelete: 'Cancel',
  chatSelectButtonNo: 'Delete',
  chatDeleteMessagesTitle: 'Delete Messages',
  chatDeleteMessagesDescription: 'Delete these messages?',
  chatDeleteMessagesButtonTitleYes: 'Confirm',
  chatDeleteMessagesButtonTitleNo: 'Cancel',
  chatArchiveButtonRestore: 'Restore',
  chatArchiveButtonNo: 'Delete',
  chatNoUsersCurtainTitle: 'Oops!',
  chatsNoUsersCurtainText: 'Looks like there are no users except you. Invite friends to start chatting.',
  chatsNoUsersCurtainCancelButtonTitle: 'Cancel',
  chatsNoUsersCurtainCopyButtonTitle: 'Copy App link',
  chatsAppLinkCopiedAlertText: 'Link copied!',
  chatsTooFewUsers: 'Please select at least one user to start chatting!',
  chatsError: 'Something went wrong!'
}
